import {
	Button,
	createStyles,
	makeStyles,
	TextField,
	Theme,
} from "@material-ui/core";
import Dialog from "@material-ui/core/Dialog";
import { useRef } from "react";
import {
	DROP_TYPES,
	FONTS,
	PRIMARY_COLOR,
	SECONDARY_COLOR,
} from "../constants";
import { safeTrim } from "../helpers/DataHelpers";
import { stateType } from "../state";
import StyledDropzone from "./Common/DropZone";
import { processDroppedData } from "./DataIngestion/DropZoneBox";

const useStyles = makeStyles((theme: Theme) => {
	return createStyles({
		filterRow: { display: "flex", flexDirection: "row" },
		textField: {
			"& .MuiInputBase-input": {
				color: PRIMARY_COLOR, // Text color
			},
			"& .MuiInput-underline:before": {
				borderBottomColor: SECONDARY_COLOR, // Semi-transparent underline
			},
			"& .MuiInput-underline:hover:before": {
				borderBottomColor: SECONDARY_COLOR, // Solid underline on hover
			},
			"& .MuiInput-underline:after": {
				borderBottomColor: SECONDARY_COLOR, // Solid underline on focus
			},
		},
		textFieldInvalid: {
			"& .MuiInputBase-input": {
				color: PRIMARY_COLOR, // Text color
			},
			"& .MuiInput-underline:before": {
				borderBottomColor: "red", // Semi-transparent underline
			},
			"& .MuiInput-underline:hover:before": {
				borderBottomColor: "red", // Solid underline on hover
			},
			"& .MuiInput-underline:after": {
				borderBottomColor: "red", // Solid underline on focus
			},
		},
	});
});

export function NewDashPopup({ state }: stateType) {
	const classes = useStyles();
	const valueRef = useRef(""); //creating a refernce for TextField Component

	function handleClose() {
		state.setIsNewDashPopUpOpen(false);
	}

	async function callbackFunction(dataStr: string) {
		state.saveState._loaded = false;
		state.setSaveState(state.saveState);

		await processDroppedData(
			state,
			dataStr,
			"Loading Data...",
			true,
			new Set(),
			undefined,
			DROP_TYPES.newDashPopup
		);

		// handleClick();
	}
	function handleClick() {
		// state.dashboardNames.unshift(state.tempDashName);
		// state.saveState.dashboardName = state.tempDashName;
		// state.setSaveState(state.saveState);
		// state.setDashboardNames(state.dashboardNames);
		// state.dropzoneOpen(true);
	}

	function handleChange(e) {
		let val = e.target.value;
		let val_test = val.replaceAll(" ", "");
		if (!/^[a-zA-Z0-9]+$/.test(val_test) && val_test !== "") {
			return;
		}
		state.setTempDashName(val);
	}
	function handleInvalid() {}
	const validName =
		!state.dashboardNames.includes(safeTrim(state.tempDashName)) &&
		state.tempDashName.length > 2;
	let continueButton = (
		<Button
			// variant={"outlined"}
			variant="contained"
			color="primary"
			style={{
				fontFamily: FONTS,
				fontWeight: "bold",
				marginLeft: "20px",
				fontSize: "13px",
				marginRight: "20px",
				marginBottom: "20px",
				backgroundColor: SECONDARY_COLOR,
				height: "35px",
				width: "130px",
			}}
			// onClick={handleClick}
		>
			Continue
		</Button>
	);
	let continueButtonInvalid = (
		<Button
			// variant={"outlined"}
			variant="contained"
			color="primary"
			style={{
				fontFamily: FONTS,
				color: !validName ? "rgba(255,255,255,0.6)" : "white",
				fontWeight: "bold",
				marginLeft: "20px",
				fontSize: "13px",
				marginRight: "20px",
				marginBottom: "20px",
				backgroundColor: SECONDARY_COLOR,
				height: "35px",
				width: "130px",
			}}
			onClick={handleInvalid}
			disabled={!validName}
		>
			Continue
		</Button>
	);

	return (
		<Dialog
			open={state.isNewDashPopUpOpen}
			maxWidth="sm"
			onClose={handleClose}
			PaperProps={{
				style: {
					boxShadow: "none",
				},
			}}
		>
			<div
				style={{
					width: "350px",
					display: "flex",
					flexDirection: "column",
					alignItems: "center",
				}}
			>
				<div
					style={{
						fontFamily: FONTS,
						margin: "20px",
						marginTop: "10px",
						display: "flex",
						flexDirection: "column",
					}}
				>
					<div
						style={{
							fontWeight: "bold",
							marginLeft: "-12px",
							marginTop: "10px",
						}}
					>
						New Dashboard
					</div>
					<div
						style={{
							fontSize: "14px",
							marginLeft: "-12px",
							marginTop: "3px",
							color: "rgba(0,0,0,0.5)",
						}}
					>
						Enter a name for your new dashboard.
					</div>
				</div>
				<div style={{ display: "flex", flexDirection: "column" }}>
					<div
						className={classes.filterRow}
						style={{ marginLeft: "20px", marginTop: "-10px" }}
					>
						<TextField
							id="outlined-basic"
							variant="standard"
							size="small"
							style={{ width: "280px", marginLeft: "0px" }}
							className={classes.textField}
							value={state.tempDashName}
							onChange={handleChange}
							inputProps={{
								maxLength: 20,
							}}
							inputRef={valueRef}
						/>
					</div>
					<div
						style={{
							display: "flex",
							flexDirection: "row",
							marginTop: "20px",
						}}
					>
						{validName ? (
							<StyledDropzone
								state={state}
								callbackFunction={callbackFunction}
								saveOpen={false}
								button={continueButton}
							></StyledDropzone>
						) : (
							continueButtonInvalid
						)}
						{/* <StyledDropzone
              state={state}
              callbackFunction={callbackFunction}
              saveOpen={false}
              button={continueButton}
            ></StyledDropzone> */}
						<Button
							variant="contained"
							color="primary"
							onClick={handleClose}
							style={{
								backgroundColor: "rgba(0,0,0,.2)",
								fontFamily: FONTS,
								fontWeight: "bold",
								height: "35px",
								marginLeft: "20px",
							}}
							size="large"
						>
							Cancel
						</Button>
					</div>
				</div>
			</div>
		</Dialog>
	);
}
